import React, { useMemo } from "react";
import { buildPaginationItems } from "./memberUtils";
import {
  MembersPaginationButton,
  MembersPaginationEllipsis,
  MembersPaginationNav,
} from "./Members.styles";

const MembersPagination = ({ activePage, totalPages, onChange }) => {
  const pageItems = useMemo(
    () => buildPaginationItems(activePage, totalPages),
    [activePage, totalPages]
  );

  if (totalPages <= 1) {
    return null;
  }

  const goToPage = (page) => {
    const target = Math.max(1, Math.min(page, totalPages));
    if (target !== activePage) {
      onChange(target);
    }
  };

  return (
    <MembersPaginationNav aria-label="Pagination">
      <MembersPaginationButton
        type="button"
        disabled={activePage === 1}
        aria-label="Previous page"
        onClick={() => goToPage(activePage - 1)}
      >
        <span className="material-icons" aria-hidden="true">
          chevron_left
        </span>
      </MembersPaginationButton>

      {pageItems.map((item) =>
        item.type === "ellipsis" ? (
          <MembersPaginationEllipsis
            key={`ellipsis-${item.key}`}
            aria-hidden="true"
          >
            …
          </MembersPaginationEllipsis>
        ) : (
          <MembersPaginationButton
            key={item.value}
            type="button"
            $active={item.value === activePage}
            aria-label={`Go to page ${item.value}`}
            aria-current={item.value === activePage ? "page" : undefined}
            onClick={() => goToPage(item.value)}
          >
            {item.value}
          </MembersPaginationButton>
        )
      )}

      <MembersPaginationButton
        type="button"
        disabled={activePage === totalPages}
        aria-label="Next page"
        onClick={() => goToPage(activePage + 1)}
      >
        <span className="material-icons" aria-hidden="true">
          chevron_right
        </span>
      </MembersPaginationButton>
    </MembersPaginationNav>
  );
};

export default MembersPagination;
